import {createSlice} from "@reduxjs/toolkit";
import {storage} from './Storage';

const TOKEN_STATE = 'token';
const AUTHENTICATION_KEY = 'authentication';

const NEED_CREATE = 0;
const NEED_REFRESH = 1;
const USE_ABLE = 2;

const tokenSlice = createSlice({
    name: TOKEN_STATE,
    initialState: {
        value: '',
        ttl: null,
        refreshTtl: null,
    },
    reducers: {
        setToken: (state, action) => {
            storage.clear(AUTHENTICATION_KEY);
            if (action.payload) {
                let token = action.payload;
                state.value = token.value;
                state.ttl = token.ttl;
                state.refreshTtl = token.refreshTtl ? token.refreshTtl : token.ttl;
                storage.set(AUTHENTICATION_KEY, {
                    value: state.value,
                    ttl: state.ttl,
                    refreshTtl: state.refreshTtl,
                });
            }
        },
        resetToken: (state) => {
            state.value = '';
            state.ttl = null;
            state.refreshTtl = null;
            storage.set(AUTHENTICATION_KEY, {
                value: state.value,
                ttl: state.ttl,
                refreshTtl: state.refreshTtl,
            });
        },
        initToken: (state) => {
            let token = storage.get(AUTHENTICATION_KEY);
            if (token) {
                state.value = token.value;
                state.ttl = token.ttl;
                state.refreshTtl = token.refreshTtl ? token.refreshTtl : token.ttl;
            }
        }
    }
});

const {setToken, resetToken, initToken} = tokenSlice.actions;
const tokenSelector = (state) => {
    let refreshTtl = refreshTtlSelector(state);
    if (refreshTtl && refreshTtl.getTime() > Date.now()) {
        return state.value;
    } else {
        let token = storage.get(AUTHENTICATION_KEY);
        if (token !== undefined && token && token['value'] !== undefined) {
            return token['value'];
        }
        return null;
    }
};

const tokenState = (state) => {
    return state(TOKEN_STATE);
}
const ttlSelector = (state) => {
    return state.ttl ? new Date(state.ttl) : null;
};

const refreshTtlSelector = (state) => {
    return state.refreshTtl ? new Date(state.refreshTtl) : null;
};

const getToken = (state) => {
    return tokenSelector(tokenState(state));
};

const tokenStatus = (state) => {
    let token = tokenState(state);
    let ttl = ttlSelector(token);
    let refreshTtl = refreshTtlSelector(token);
    let value = tokenSelector(token);
    let now = Date.now();
    if (value && ttl && refreshTtl && ttl.getTime() < now && refreshTtl.getTime() > now) {
        return NEED_REFRESH;
    } else {
        if (!value || !ttl || !refreshTtl || refreshTtl.getTime() < now) {
            return NEED_CREATE;
        } else {
            return USE_ABLE;
        }
    }
};

export {
    tokenSelector,
    setToken,
    resetToken,
    initToken,
    getToken,
    refreshTtlSelector,
    ttlSelector,
    tokenStatus,
    TOKEN_STATE,
    NEED_CREATE,
    NEED_REFRESH,
    USE_ABLE,
};
export default tokenSlice.reducer;
